<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4><strong>Data Dokumen/Lampiran</strong></h4>
        <hr />
      </CCol>
    </CRow>

    <!-- <CRow>
      <CCol col="12" md="12" lg="12">
        <b-button variant="primary" v-b-modal.modal-input-lampiran
          ><CIcon name="cil-plus" /> Tambah Data</b-button
        >
      </CCol>
    </CRow> -->
    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #fileKebutuhan="{ item }">
            <b-button variant="success" size="sm" v-if="item.fileKebutuhan != null" @click="view(item.fileKebutuhan)">Lihat File</b-button>
            <b-button v-else variant="danger" size="sm">Tidak Ada File</b-button>
          </template>
          <!-- <template #cell(actions)="item">
            <b-button
              variant="warning"
              class="mr-1"
              v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
              v-b-modal.modal-edit-lampiran
              @click="data = item.item"
              ><CIcon name="cil-pencil" /> {{ item.actions }}</b-button
            >

            <b-button
              variant="danger"
              class="mr-1"
              v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
              v-b-modal.modal-delete-lampiran
              @click="data = item.item"
              ><CIcon name="cil-trash" /> {{ item.actions }}</b-button
            >
          </template> -->
        </CDataTable>
      </CCol>
    </CRow>
    <!-- <modal-input />
    <modal-edit />
    <modal-delete /> -->
  </div>
</template>
<script>
// import modalInput from "./modalInput.vue";
// import modalEdit from "./modalEdit.vue";
// import modalDelete from "./modalDelete.vue";
export default {
  props: ["data"],
  components: {
    // modalInput,
    // modalEdit,
    // modalDelete,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center",
        },
        {
          key: "namaKebutuhan",
          label: "Lampiran",
          sortDirection: "desc",
          _style: "width: 80%;",
          class: "text-left",
          filter: false,
        },
        {
          key: "fileKebutuhan",
          label: "File Lampiran",
          sortDirection: "desc",
          _style: "width: 20%;",
          class: "text-left",
          filter: false,
          sorter: false,
        },
      ],
      tableBusy: false,
    };
  },
  computed: {},
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDataAsuransi();
      }
    },
    activeTab(newVal) {
      if (newVal === 4) {
        // this.getDataAsuransi();
        this.getDokumen();
      }
    },
  },

  mounted() {},
  methods: {
    async getDokumen() {
      const vm = this;
      let listBerkasFile = await this.$axios.get("dataKaryawan/detailsByDataKaryawanId/" + this.$route.query.dataKaryawanId);
      // console.log('listBerkasFile', listBerkasFile);
      vm.items =
        listBerkasFile.data.status == 200 && listBerkasFile.data.data.length > 0
          ? listBerkasFile.data.data[0].berkasFile.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
              };
            })
          : [];
    },
    view(x) {
      window.open(`${this.$be}asset/file/${x}`);
    },
  },
};
</script>
